module.exports = __webpack_public_path__ + "static/img/proposition.c76622b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/proposition.png
// module id = B2NY
// module chunks = 0